export const ThemeIconSun = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41.886"
      height="41.886"
      viewBox="0 0 41.886 41.886"
      {...props}
    >
      <g id="sun-svgrepo-com" transform="translate(0 -0.003)">
        <circle
          id="Ellipse_53"
          data-name="Ellipse 53"
          cx="10.473"
          cy="10.473"
          r="10.473"
          transform="translate(10.473 10.476)"
          fill="currentColor"
        />
        <path
          id="Path_2524"
          data-name="Path 2524"
          d="M7.855,30.615A2.616,2.616,0,0,0,5.237,28H2.618a2.618,2.618,0,0,0,0,5.236H5.236A2.617,2.617,0,0,0,7.855,30.615Z"
          transform="translate(0 -9.672)"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          id="Path_2525"
          data-name="Path 2525"
          d="M10.821,45.734,8.967,47.588a2.618,2.618,0,0,0,3.7,3.7l1.854-1.854a2.618,2.618,0,1,0-3.7-3.7Z"
          transform="translate(-2.833 -15.535)"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          id="Path_2526"
          data-name="Path 2526"
          d="M30.621,52A2.616,2.616,0,0,0,28,54.617v2.619a2.618,2.618,0,0,0,5.236,0l0-2.619A2.614,2.614,0,0,0,30.621,52Z"
          transform="translate(-9.675 -17.965)"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          id="Path_2527"
          data-name="Path 2527"
          d="M49.44,45.737a2.616,2.616,0,1,0-3.7,3.7l1.852,1.851a2.618,2.618,0,0,0,3.7-3.7Z"
          transform="translate(-15.539 -15.536)"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          id="Path_2528"
          data-name="Path 2528"
          d="M57.242,28,54.618,28a2.615,2.615,0,0,0,0,5.231h2.619A2.618,2.618,0,0,0,57.242,28Z"
          transform="translate(-17.968 -9.672)"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          id="Path_2529"
          data-name="Path 2529"
          d="M49.44,14.521l1.851-1.852a2.618,2.618,0,0,0-3.7-3.705L45.74,10.82a2.616,2.616,0,0,0,3.7,3.7Z"
          transform="translate(-15.539 -2.831)"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          id="Path_2530"
          data-name="Path 2530"
          d="M30.621,7.852a2.61,2.61,0,0,0,2.618-2.613V2.621a2.618,2.618,0,0,0-5.236,0l.005,2.623A2.607,2.607,0,0,0,30.621,7.852Z"
          transform="translate(-9.675)"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          id="Path_2531"
          data-name="Path 2531"
          d="M10.825,14.519a2.616,2.616,0,0,0,3.7-3.7L12.674,8.968a2.62,2.62,0,0,0-3.71,3.7Z"
          transform="translate(-2.832 -2.832)"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};
